/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaTagText from 'DesignSystem/TysiaTag/TysiaTagText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/TopBar/Order/Content"
  
}) {
let orderTitleValueData = fromData.useDataValue({ viewPath,
context: 'order',
path: 'title',
})
let orderStatusValueData = fromData.useDataValue({ viewPath,
context: 'order',
path: 'status',
})
let aggregateData = fromHelpers.getOrder(orderTitleValueData, orderStatusValueData)
  return (<React.Fragment
>
<TysiaTag
  viewPath={`${viewPath}/TysiaTag`}
 style="filled"
 type="grey"
 size="tiny"
 marginTop={6}
>
{childProps => (
<TysiaTagText
{...childProps}
  viewPath={`${viewPath}/TysiaTagText`}
 data="order.title"
 data="order.status"
 aggregate="helpers.js getOrder"
 text={aggregateData}
/>
)}
</TysiaTag>
{children}
</React.Fragment>)
}